import React,{ useContext, useState } from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import CircularProgress from '@material-ui/core/CircularProgress';
// @material-ui/icons
import Close from "@material-ui/icons/Close";
import Check from "@material-ui/icons/Check";
// core components
import Danger from "components/Typography/Danger.js";
import Success from "components/Typography/Success.js";
import Button from "components/CustomButtons/Button.js";
import WhatsAppIcon from '@material-ui/icons/WhatsApp';

import { createCheckoutSession } from "firebase/checkout";
import { UserContext } from 'context/userContext'
import { Assinar } from "../../firebase/AssinarButton";


const styles = {
  tableUpgradeWrapper: {
    display: "block",
    width: "100%",
    overflowX: "auto",
    WebkitOverflowScrolling: "touch",
    MsOverflowStyle: "-ms-autohiding-scrollbar"
  },
  table: {
    width: "100%",
    maxWidth: "100%",
    marginBottom: "1rem",
    backgroundColor: "transparent",
    borderCollapse: "collapse",
    display: "table",
    borderSpacing: "2px",
    borderColor: "grey",
    "& thdead tr th": {
      fontSize: "1.063rem",
      padding: "12px 8px",
      verticalAlign: "middle",
      fontWeight: "300",
      borderTopWidth: "0",
      borderBottom: "1px solid rgba(0, 0, 0, 0.06)",
      textAlign: "inherit"
    },
    "& tbody tr td": {
      padding: "12px 8px",
      verticalAlign: "middle",
      borderTop: "1px solid rgba(0, 0, 0, 0.06)"
    },
    "& td, & th": {
      display: "table-cell"
    }
  },
  center: {
    textAlign: "center"
  },
  buttonProgress: {
   position: 'absolute',
   top: '50%',
   left: '50%',
   marginTop: -12,
   marginLeft: -12,
   color: 'white',
 },
};

const useStyles = makeStyles(styles);

export default function PriceTable() {
  const { currentUser, isSignedIn } = useContext(UserContext)
  const classes = useStyles();
  const [loadingCheckOut, setLoadingCheckOut] = useState(false);

  return (
            <div className={classes.tableUpgradeWrapper}>
              <table className={classes.table}>
                <thead>
                  <tr>
                    <th />
                    <th className={classes.center}>Gratuito</th>
                    <th className={classes.center}>PRO Individual</th>
                    <th className={classes.center}>PRO Grupo</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Usuários</td>
                    <td className={classes.center}>1</td>
                    <td className={classes.center}>1</td>
                    <td className={classes.center}>Ilimitados</td>
                  </tr>
                  <tr>
                    <td>Atendimentos</td>
                    <td className={classes.center}>20</td>
                    <td className={classes.center}>Ilimitados</td>
                    <td className={classes.center}>Ilimitados</td>
                  </tr>
                  <tr>
                    <td>Ficha Personalizada</td>
                    <td className={classes.center}>
                      <Danger>
                        <Close />
                      </Danger>
                    </td>
                    <td className={classes.center}>
                      <Success>
                        <Check />
                      </Success>
                    </td>
                    <td className={classes.center}>
                      <Success>
                        <Check />
                      </Success>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Termo de Consentimento
                    </td>
                    <td className={classes.center}>
                      <Success>
                        <Check />
                      </Success>
                    </td>
                    <td className={classes.center}>
                      <Success>
                        <Check />
                      </Success>
                    </td>
                    <td className={classes.center}>
                      <Success>
                        <Check />
                      </Success>
                    </td>
                  </tr>
                  <tr>
                    <td>Orçamento</td>
                    <td className={classes.center}>
                      <Success>
                        <Check />
                      </Success>
                    </td>
                    <td className={classes.center}>
                      <Success>
                        <Check />
                      </Success>
                    </td>
                    <td className={classes.center}>
                      <Success>
                        <Check />
                      </Success>
                    </td>
                  </tr>
                  <tr>
                    <td>Suporte</td>
                    <td className={classes.center}>
                      <Danger>
                        <Close />
                      </Danger>
                    </td>
                    <td className={classes.center}>
                      <Success>
                        <Check />
                      </Success>
                    </td>
                    <td className={classes.center}>
                      <Success>
                        <Check />
                      </Success>
                    </td>
                  </tr>
                  <tr>
                    <td />
                    <td className={classes.center}>Grátis</td>
                    <td className={classes.center}>R$99/mês</td>
                    <td className={classes.center}>A partir de R$499 mensais</td>
                  </tr>
                  <tr>
                    <td />
                    <td className={classes.center}>
                      <Button round href="/new">
                        Testar
                      </Button>
                    </td>
                    <td className={classes.center}>
                      {isSignedIn ? (
                        <Button
                          round
                          color="success"
                          disabled={loadingCheckOut}
                          onClick={(event) => {
                            event.preventDefault()
                            Assinar(currentUser.uid)
                            setLoadingCheckOut(true)
                          }}
                        >
                          Assinar Pro {loadingCheckOut && <CircularProgress size={20} className={classes.buttonProgress}/>}
                        </Button>)
                      : (
                        <Button round
                                href="/login"
                        >
                          Assinar Pro
                        </Button>
                      )}
                    </td>
                    <td className={classes.center}>
                      <Button round
                              color="success"
                              href="https://wa.me/5579998522626?text=Tenho%20uma%20dúvida%20referente%20ao%20site">
                        <WhatsAppIcon/> CONTATO
                      </Button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
  );
}
